import { render, staticRenderFns } from "./CreateAttendanceKidCustomExcelV3ForGroup.vue?vue&type=template&id=1b7b6934&scoped=true"
import script from "./CreateAttendanceKidCustomExcelV3ForGroup.vue?vue&type=script&lang=js"
export * from "./CreateAttendanceKidCustomExcelV3ForGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7b6934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7b6934')) {
      api.createRecord('1b7b6934', component.options)
    } else {
      api.reload('1b7b6934', component.options)
    }
    module.hot.accept("./CreateAttendanceKidCustomExcelV3ForGroup.vue?vue&type=template&id=1b7b6934&scoped=true", function () {
      api.rerender('1b7b6934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attendance-v2/dialog/CreateAttendanceKidCustomExcelV3ForGroup.vue"
export default component.exports